// Sportpacks Redesign - (c) 2026 NextPercent, nextpercent.de
// Lizenziert ausschliesslich fuer sport-packs.myshopify.com.
// Einsatz in weiteren Shops nur mit schriftlicher Genehmigung: info@nextpercent.de
// A real cart expiry, enabled only in this draft's theme assets and app settings.
(() => {
  if (customElements.get('sp-cart-expiry')) return;
  const german = document.documentElement.lang.startsWith('de');
  let clearing = false;
  let retryAt = 0;
  const fallback = new Map();
  const read = key => { try { return localStorage.getItem(key); } catch { return fallback.get(key); } };
  const write = (key, value) => { fallback.set(key, value); try { localStorage.setItem(key, value); } catch {} };
  const remove = key => { fallback.delete(key); try { localStorage.removeItem(key); } catch {} };

  class CartExpiry extends HTMLElement {
    connectedCallback() {
      this.key = `sp-cart-expiry-${this.dataset.theme}`;
      this.count = Number(this.dataset.count);
      this.time = this.querySelector('[data-expiry-time]');
      this.note = this.querySelector('[data-expiry-note]');
      this.label = this.querySelector('[data-expiry-label]');
      this.status = this.querySelector('[data-expiry-status]');
      if (!this.count) {
        remove(this.key);
        let expired = false;
        try { expired = Date.now() - Number(sessionStorage.getItem(`${this.key}-cleared`)) < 300000; } catch {}
        if (expired) {
          this.hidden = false;
          this.time.hidden = true;
          this.label.textContent = german ? 'Dein Warenkorb wurde geleert.' : 'Your cart has been cleared.';
          this.note.textContent = german ? 'Die 20 Minuten sind abgelaufen. Du kannst eine neue Auswahl zusammenstellen.' : 'The 20 minutes have elapsed. You can start a new selection.';
        }
        return;
      }
      try { sessionStorage.removeItem(`${this.key}-cleared`); } catch {}
      const saved = Number(read(this.key));
      this.deadline = saved > 0 ? saved : Date.now() + Number(this.dataset.duration);
      write(this.key, String(this.deadline));
      this.hidden = false;
      this.tick = this.tick.bind(this);
      this.tick();
      this.interval = setInterval(this.tick, 1000);
      document.addEventListener('visibilitychange', this.tick);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
      document.removeEventListener('visibilitychange', this.tick);
    }

    tick() {
      const persisted = Number(read(this.key));
      if (!persisted && !clearing) {
        window.location.reload();
        return;
      }
      if (persisted > 0) this.deadline = persisted;
      const seconds = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      this.time.textContent = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
      const minutes = Math.ceil(seconds / 60);
      if (minutes !== this.lastMinutes) {
        this.status.textContent = german ? `Dein Warenkorb wird in ${minutes} Minuten geleert.` : `Your cart will be cleared in ${minutes} minutes.`;
        this.lastMinutes = minutes;
      }
      if (!seconds && !clearing && Date.now() >= retryAt) this.expire();
    }

    async expire() {
      clearing = true;
      const clear = async () => {
        // Another tab may have completed expiry while this one waited for the lock.
        const deadline = Number(read(this.key));
        if (!deadline || deadline > Date.now()) return;
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/clear.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}'
        });
        if (!response.ok) throw new Error('Cart clearing failed');
        const cart = await response.json();
        if (cart.item_count !== 0) throw new Error('Cart is not empty');
        remove(this.key);
        try { sessionStorage.setItem(`${this.key}-cleared`, String(Date.now())); } catch {}
        // Fresh server-rendered cart, totals and recommendations stay consistent.
        window.location.reload();
      };
      try {
        if (navigator.locks) await navigator.locks.request(this.key, clear);
        else await clear();
      } catch {
        retryAt = Date.now() + 5000;
        this.note.textContent = german ? 'Zeit abgelaufen. Die Verbindung wird erneut geprüft …' : 'Time elapsed. Retrying the connection …';
      } finally {
        clearing = false;
      }
    }
  }
  customElements.define('sp-cart-expiry', CartExpiry);
})();
